import { Canvas, createCanvas, createImageData, CanvasRenderingContext2D } from 'canvas';
import { Transform } from '../utils';
import { Img, IType, Renderer, registerRendererType } from '../image-base';
import * as utif from 'utif';

export interface Tiff extends Img {}

export type Type = Tiff;

export function makeTiff(id: string, data: ArrayBuffer[]): Tiff {
    return {
        id,
        iType: IType.Tiff,
        data,
        dataSize: data.map((buf: ArrayBuffer): number => buf.byteLength),
        frames: data.length,
    }
}

export function isTiff(x: Img): x is Tiff {
    return x.iType === IType.Tiff;
}

export function tiffDetect(buffer: ArrayBuffer): boolean {
    if (buffer.byteLength < 4) {
        return false;
    }
    const data = new Uint8Array(buffer);
    console.log('IS_TIFF: ',
        data[0].toString(16),
        data[1].toString(16),
        data[2].toString(16),
        data[3].toString(16)
    );
    return (data[0] === 0x49 && data[1] === 0x49 && data[2] === 0x2a && data[3] === 0x00) ||
        (data[0] === 0x4d && data[1] === 0x4d && data[2] === 0x00 && data[3] === 0x2a);
}

export class TiffRenderer implements Renderer {
    public index: number;
    public readonly img: Tiff;
    private canvas?: Canvas;

    public constructor(img: Tiff) {
        this.img = img;
        this.index = 0;
    }

    public destroy(): void {
        //this.img.data = [];
    }

    private toCanvas(data: ArrayBuffer): void {
        const ifds = utif.decode(data);
        utif.decodeImage(data, ifds[0]);
        this.img.cols = ifds[0].width;
        this.img.rows = ifds[0].height;
        this.canvas = createCanvas(this.img.cols, this.img.rows);
        const rgba  = utif.toRGBA8(ifds[0]);
        const context = this.canvas.getContext('2d', {alpha: false});
        context.putImageData(createImageData(new Uint8ClampedArray(rgba), this.img.cols, this.img.rows), 0, 0);
    }

    public async render(): Promise<void> {
        /*const data = this.img.data[0];
        if (!data) {
            return Promise.reject('image is not loaded');
        }
        const ifds = utif.decode(data);
        utif.decodeImage(data, ifds[0]);
        this.img.cols = ifds[0].width;
        this.img.rows = ifds[0].height;
        if (!this.canvas) {
            this.canvas = createCanvas(this.img.cols, this.img.rows);
        }
        const rgba  = utif.toRGBA8(ifds[0]);
        const context = this.canvas.getContext('2d', {alpha: false});
        context.putImageData(createImageData(new Uint8ClampedArray(rgba), this.img.cols, this.img.rows), 0, 0);
        return Promise.resolve();*/
    }

    public async renderThumbnail(): Promise<ImageData> {
        const data = this.img.data[0];
        if (!data) {
            throw 'image is not loaded';
        }
        const ifds = utif.decode(data);
        utif.decodeImage(data, ifds[0]);
        const cols = ifds[0].width;
        const rows = ifds[0].height;
        this.img.cols = cols;
        this.img.rows = rows;
        const rgba  = utif.toRGBA8(ifds[0]);
        const c = createCanvas(cols, rows);
        const x = c.getContext('2d', { alpha: false });
        if (!x) {
            throw 'hidden CONTEXT is null';
        }
        x.putImageData(createImageData(new Uint8ClampedArray(rgba), cols, rows), 0, 0); 
        const canvas = createCanvas(120 * cols / rows, 120);
        const cxt = canvas.getContext('2d', { alpha: false });
        if (!cxt) {
            throw 'visible CONTEXT is null';
        }
        cxt.drawImage(c as unknown as CanvasImageSource, 0, 0, c.width, c.height, 0, 0, canvas.width, canvas.height);
        return cxt.getImageData(0, 0, canvas.width, canvas.height);
    }

    public async animationFrame(context: CanvasRenderingContext2D, t: Transform): Promise<void> {
        //context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.fillStyle = 'black';
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        if (this.canvas) {
            context.setTransform(t.s, t.r, -t.r, t.s, t.tx, t.ty);
            context.drawImage(this.canvas, 0, 0);
            //    Math.floor(context.canvas.width / 2 - this.canvas.width / 2),
            //    Math.floor(context.canvas.height / 2 - this.canvas.height / 2)
            //);  
        }
    }

    public async load(
        begin: () => Promise<void>,
        frame: (image: Img, frame: number) => Promise<ArrayBuffer>, 
        end: () => Promise<void>,
        render: () => Promise<void>,
        progress: (p: number) => void,
    ): Promise<void> {
        await begin();
        this.img.data.length = this.img.frames;
        let j = this.index;
        for (let i = 0; i < this.img.frames; ++i) {
            j = (j === this.img.frames) ? 0 : j;
            const f = await frame(this.img, j);
            //this.img.data[j] = f;
            if (j === this.index) {
                this.toCanvas(f);
                await render();
            }
            progress(((i + 2) * 100.0) / (this.img.frames + 1));
            ++j;
        }
        await end();
    }

    public convexMean(): {mean?: number, stddev?: number} {
        return {};
    }
}

export function isTiffRenderer(renderer: Renderer): renderer is TiffRenderer {
    return isTiff(renderer.img);
}

registerRendererType({
    name: 'TiffRenderer',
    hasMime(mime: string) {
        return mime === 'image/tiff';
    },
    makeImg(id: string, buffer: ArrayBuffer) {
        return makeTiff(id, [buffer]);
    },
    isThis(resource: Img) {
        return resource.iType === IType.Tiff;
    },
    makeRenderer(resource: Tiff): Renderer {
        return new TiffRenderer(resource);
    }
});